export default "__VITE_ASSET__BRgCNhVE__"